import { onSignalREvent } from '../../signalRBus'
import { SIGNAL_R_MESSAGES, SIGNAL_R_SCOPES } from 'src/signalR/types'
import type { GroupChatSystemMessageSignalRPayload } from 'src/signalR/types'
import { useMessagingServiceStore } from 'src/stores/messaging.service.store'

onSignalREvent(
  SIGNAL_R_SCOPES.message,
  SIGNAL_R_MESSAGES.groupChatSystemMessage,
  (text, response) => {
    const payload: GroupChatSystemMessageSignalRPayload = JSON.parse(text)
    const messagingServiceStore = useMessagingServiceStore()
    messagingServiceStore.handleGroupChatSystemMessageEvent(
      payload,
      response.OrgId,
    )
  },
)
